import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <div className="bg-brand-dark px-4" data-id="element-54">
      <div className="max-w-3xl mx-auto flex items-center gap-3 bg-brand-card rounded-lg px-4 py-3 border border-brand-accent/20" data-id="element-55">
        <ShieldCheck className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-56" />
        <p className="text-sm text-gray-400 font-body" data-id="element-57">
          <span className="font-heading font-bold text-white uppercase text-sm" data-id="element-58">
            🛡️ Garantía 7 días sin riesgo —{' '}
          </span>
          Si no te convence, te devolvemos el 100% de tu dinero. Sin preguntas.
        </p>
      </div>
    </div>;
}